/* eslint-disable */
import { useEffect, useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Services
import i18n from "../i18n";

// Lib
import { Helmet } from "react-helmet";

// Utils
import PageContent from "./ListingPageContent";
import { ShowBottomBar, ShowTopBar } from "../services/ToggleNativeBar";
import { useModal } from "../context/ModalContext";
import parseNestedUrl from "../utils/parseNestedUrl";
import { useApp } from "../context/AppContext";
import usePageData from "../hooks/usePageData";

const ListingPage = () => {
  const { state } = useModal();
  const { isOnboardingDisabled } = useApp();
  const { name, content, theme } = usePageData();
  const location = useLocation();

  useEffect(() => {
    // Confirm if there's an after configuration.
    // if there is -> check modal state
    // if there is NOT -> then just show Bars(true)

    const { basePathname, currentPageNumber } = parseNestedUrl(window.location.pathname);
    const configExists = () => {
      const pageKey = basePathname === "/" ? "homepage" : basePathname;

      const pageConfig = window.config?.pages?.[pageKey];
      const flows = window.config?.flows;

      return pageConfig?.flow?.some(
        (flow_reference) => flows?.[flow_reference]?.triggerEvent === "after"
      );
    };

    if (configExists()) {
      ShowTopBar(!state.isOpen);
      ShowBottomBar(!state.isOpen);
      return;
    }

    if (isOnboardingDisabled !== undefined && currentPageNumber === undefined) {
      ShowTopBar(true);
      ShowBottomBar(true);
    }
  }, [state, isOnboardingDisabled]);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0 });

    // The nested SlideRoutes wrapper can be the real scroll container on some
    // tenants; reset it too so the destination page starts at the top (APS-2013).
    const slideRoutes = document.querySelector(".slide-routes");
    if (slideRoutes) {
      slideRoutes.scrollTop = 0;
    }
  }, [location.pathname]);

  useEffect(() => {
    // Clear RecoEngine session when ListingPage loads
    // This ensures fresh session when navigating to homepage or other main pages
    const recoEngineSession = sessionStorage.getItem("recoEngine_session");
    if (recoEngineSession) {
      sessionStorage.removeItem("recoEngine_session");
    }
  }, []);

  return (
    <>
      <Helmet title={i18n.t(content?.pageTitle)} />
      <PageContent json={content} theme={theme} pageName={name} />
    </>
  );
};

export default ListingPage;
